import AccountApi from "./AccountApi";
import AdvertisementDistributeApi from "./AdvertisementDistributeApi";
import AIApi from "./AIApi";
import DeviceApi from "./DeviceApi";
import ExtensionApi from "./ExtensionApi";
import GlobalApi from "./GlobalApi";
import IndustryApi from "./IndustryApi";
import OneApi from "./OneApi";
import RecordApi from "./RecordApi";
import ResourcesApi from "./ResourcesApi";
import TemplateApi from "./TemplateApi";
import TopicApi from "./TopicApi";

/**
 * API请求
 */
export default class WebApiService {
    /**
     * 行业相关API
     */
    public industry: IndustryApi = new IndustryApi();
    /**
     * 账号相关API
     */
    public accountApi: AccountApi = new AccountApi();
    /**
     * 广告分发API
     */
    public advertisementDistribute: AdvertisementDistributeApi = new AdvertisementDistributeApi();
    /**
     * 设备相关API
     */
    public deviceApi: DeviceApi = new DeviceApi();
    /**
     * 推广相关API
     */
    public extensionApi: ExtensionApi = new ExtensionApi();
    /**
     * 全局相关API
     */
    public globalApi: GlobalApi = new GlobalApi();

    /**
     * 日志相关API
     */
    public recordApi: RecordApi = new RecordApi();

    /**
     * 资源相关API
     */
    public resourcesApi: ResourcesApi = new ResourcesApi();

    /**
     * 模板相关API
     */
    public templateApi: TemplateApi = new TemplateApi();
    /**
     * 主题相关API
     */
    public topicApi: TopicApi = new TopicApi();
    /**
     * AI Api
     */
    public aiApi: AIApi = new AIApi();
    /**
     * 大模型代理接口
     */
    public oneApi:OneApi = new OneApi();
}